import { render, staticRenderFns } from "./Pricing.vue?vue&type=template&id=43c9a889&scoped=true&"
import script from "./Pricing.vue?vue&type=script&lang=js&"
export * from "./Pricing.vue?vue&type=script&lang=js&"
import style0 from "./Pricing.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Pricing.vue?vue&type=style&index=1&id=43c9a889&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43c9a889",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LogosSection: require('/home/circleci/app/components/storyblok/LogosSection.vue').default,PricingFeatures: require('/home/circleci/app/components/storyblok/PricingFeatures.vue').default,Faqs: require('/home/circleci/app/components/storyblok/Faqs.vue').default})
